import type { CmsItem } from '~/types/cms';

type LocationEntry = Pick<CmsItem, 'slug' | 'language' | 'siteId' | 'localized'>;

type LocaleWithCraft = {
    code: string;
    craftSiteId?: number;
    language?: string;
};

export async function fetchLocationEntry(routeSlug: string, locales: LocaleWithCraft[], siteId: number) {
    const nlSiteId = (() => {
        const id = locales.find(l => l.code === 'nl')?.craftSiteId;
        return typeof id === 'number' ? id : 1;
    })();

    const fetchLocation = (slug: string, fetchSiteId: number) =>
        useAsyncGql({
            operation: 'location',
            variables: {
                siteId: fetchSiteId,
                slug
            }
        });

    let { data: location, status } = await fetchLocation(routeSlug, siteId);

    if (!location.value?.location && siteId !== nlSiteId) {
        const { data: nlLocation } = await fetchLocation(routeSlug, nlSiteId);
        const nlEntry = nlLocation.value?.location as LocationEntry | null | undefined;
        const enLocalized = nlEntry?.localized?.find((loc: CmsItem) => Number(loc.siteId) === siteId);

        if (enLocalized?.slug) {
            ({ data: location, status } = await fetchLocation(String(enLocalized.slug), siteId));
        }
    }

    return {
        entry: (location.value?.location as CmsItem | null | undefined) ?? null,
        status
    };
}

export function applyLocationI18nParams(entry: CmsItem, locales: LocaleWithCraft[]) {
    const i18nParams = resolveLocalizedSlug(entry, locales);
    const locationI18nParams = useLocationI18nParams();
    const setI18nParams = useSetI18nParams();

    locationI18nParams.value = i18nParams;
    setI18nParams(i18nParams);

    return i18nParams;
}
